import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, FolderOpen } from "lucide-react";
import AppShell, { EmptyState, NewCaseButton } from "@/components/app/AppShell";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function Dashboard() {
  const { user } = useAuth();
  const [cases, setCases] = useState(null);

  useEffect(() => { api.get("/cases").then((r) => setCases(r.data)).catch(() => setCases([])); }, []);

  return (
    <AppShell>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm text-muted">Welcome back{user?.name ? `, ${user.name.split(" ")[0]}` : ""}</p>
          <h1 className="font-serif text-2xl tracking-tight text-heading md:text-3xl">Your cases</h1>
        </div>
        <NewCaseButton />
      </div>

      {cases === null ? (
        <div className="space-y-3">{[1, 2].map((i) => <div key={i} className="h-28 animate-pulse rounded-md bg-white" />)}</div>
      ) : cases.length === 0 ? (
        <EmptyState icon={FolderOpen} title="No cases yet"
          body="Start your first application. We guide you step by step and prepare your file."
          action={<div className="mt-5"><NewCaseButton /></div>} />
      ) : (
        <div className="space-y-4">
          {cases.map((c) => {
            return (
              <Link key={c.id} to={`/app/cases/${c.id}`} data-testid={`case-card-${c.id}`}
                className="flex items-center justify-between rounded-md border border-hborder bg-white p-5 hover:border-navy">
                <div>
                  <p className="font-semibold text-heading">{c.corridor?.destination} <span className="font-normal capitalize text-muted">{c.visa_category?.replace(/_/g, " ")}</span></p>
                  <p className="text-sm text-muted">{c.applicant_name}</p>
                </div>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-navy">Continue <ArrowRight size={14} /></span>
              </Link>
            );
          })}
        </div>
      )}
    </AppShell>
  );
}
